import React from 'react'

import HandleInviteButtons from 'components/HandleInviteButtons'
import basicCustomerColumns from 'modules/Customers/columns'

export default [
  ...basicCustomerColumns,
  {
    dataIndex: 'inviteUuid',
    width: '10em',
    render: (inviteUuid, row) => <HandleInviteButtons inviteUuid={inviteUuid} setInteracted={row.setInteracted}/>,
  },
]
